export default __webpack_public_path__ + "static/tennis-dd4e9b2f03a1f99fd716e31a16b14975.jpg";